import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Home, ArrowLeft, Search, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="min-h-screen pt-20 flex items-center justify-center">
      <Helmet>
        <title>{i18n.language === 'tr' ? '404 - Sayfa Bulunamadı | SULH Siber Güvenlik' : '404 - Page Not Found | SULH Cybersecurity'}</title>
        <meta name="description" content={i18n.language === 'tr' ? 'Aradığınız sayfa bulunamadı. SULH Siber Güvenlik ana sayfasına dönün.' : 'The page you are looking for was not found. Return to SULH Cybersecurity homepage.'} />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* 404 Icon */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-32 h-32 bg-red-500/10 rounded-full mb-6">
            <Shield className="w-16 h-16 text-red-400" />
          </div>
          <h1 className="text-8xl sm:text-9xl font-bold text-red-400 mb-4">
            404
          </h1>
        </div>

        {/* Error Message */}
        <div className="mb-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            {i18n.language === 'tr' ? 'Sayfa Bulunamadı' : 'Page Not Found'}
          </h2>
          <p className="text-xl text-gray-300 mb-6">
            {i18n.language === 'tr' ? 'Böyle bir içerik bulunmamaktadır' : 'The content you are looking for does not exist'}
          </p>
          <p className="text-gray-400 max-w-2xl mx-auto">
            {i18n.language === 'tr' 
              ? 'Aradığınız sayfa taşınmış, silinmiş veya hiç var olmamış olabilir. Lütfen URL\'yi kontrol edin veya ana sayfaya dönün.'
              : 'The page you are looking for may have been moved, deleted, or never existed. Please check the URL or return to the homepage.'
            }
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <Link
            to="/"
            className="btn-primary flex items-center gap-2 px-6 py-3"
           
          >
            <Home size={20} />
            {i18n.language === 'tr' ? 'Ana Sayfaya Dön' : 'Go to Homepage'}
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="btn-secondary flex items-center gap-2 px-6 py-3"
           
          >
            <ArrowLeft size={20} />
            {i18n.language === 'tr' ? 'Geri Dön' : 'Go Back'}
          </button>
        </div>

        {/* Helpful Links */}
        <div className="glass-card p-8 max-w-2xl mx-auto">
          <h3 className="text-xl font-semibold text-white mb-6">
            {i18n.language === 'tr' ? 'Yararlı Bağlantılar' : 'Helpful Links'}
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Link
              to="/services"
              className="flex items-center gap-3 p-4 bg-slate-800/50 rounded-lg hover:bg-slate-700/50 transition-colors"
             
            >
              <Shield className="w-5 h-5 text-blue-400" />
              <span className="text-gray-300">
                {i18n.language === 'tr' ? 'Hizmetlerimiz' : 'Our Services'}
              </span>
            </Link>
            
            <Link
              to="/contact"
              className="flex items-center gap-3 p-4 bg-slate-800/50 rounded-lg hover:bg-slate-700/50 transition-colors"
             
            >
              <Search className="w-5 h-5 text-blue-400" />
              <span className="text-gray-300">
                {i18n.language === 'tr' ? 'İletişim' : 'Contact Us'}
              </span>
            </Link>
          </div>
        </div>

        {/* Security Message */}
        <div className="mt-8 p-4 bg-blue-500/10 border border-blue-500/20 rounded-lg">
          <p className="text-blue-300 text-sm">
            {i18n.language === 'tr' 
              ? '🔒 SULH Siber Güvenlik - Dijital varlıklarınızı koruyoruz'
              : '🔒 SULH Cybersecurity - Protecting your digital assets'
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
